const commentItems = [
  {
    avatar: '星',
    name: '星之读者',
    time: '2小时前',
    content: '《星之妖精》的画风真的太美了！每一话都舍不得看完，作者对细节的把控简直出神入化，妖精世界的设定也非常有意思，追了三年了一点都不腻。',
    like: 1286,
    tag: '星之妖精',
  },
  {
    avatar: '夜',
    name: '夜晚的读者',
    time: '5小时前',
    content: '妖精漫画网的加载速度确实快，用手机下拉追更特别流畅。最近入了《小妖精日常》的坑，太治愈了，每天睡前必备！推荐给所有喜欢萌系的读者。',
    like: 953,
    tag: '小妖精日常',
  },
  {
    avatar: '风',
    name: '风之旅人',
    time: '8小时前',
    content: '《魔导师传说》追了快五年了，看到200话的纪念插图真的感动到哭。这部漫画陪伴了我整个学生时代，希望妖精漫画网能一直稳定运营下去。',
    like: 2147,
    tag: '魔导师传说',
  },
  {
    avatar: '花',
    name: '花与漫画',
    time: '1天前',
    content: '不用注册就能看全部漫画这点太友好了！而且分类清晰，专题合集功能帮我发现了好多冷门好作品，现在妖精漫画网已经是我每天必刷的网站了。',
    like: 674,
    tag: '平台体验',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          读者热评
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14 max-w-lg mx-auto">
          来自妖精漫画网读者的真实评价与追更感言
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {commentItems.map((item, i) => (
            <div
              key={i}
              className="rounded-xl bg-background-50 border border-background-200 p-5 md:p-6"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-accent-700 font-heading font-bold text-sm">{item.avatar}</span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <h3 className="text-sm font-semibold text-foreground-900 whitespace-nowrap">{item.name}</h3>
                    <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                  <span className="text-xs text-foreground-400">{item.time}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">{item.content}</p>
              <div className="flex items-center gap-1 text-foreground-400 text-xs">
                <i className="ri-heart-line text-primary-400"></i>
                <span>{item.like}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}